export const clientConfigs = {
  action: {
    buildType: 'ACTION',
    style: 'action',
    logo: '../assets/img/logo_action.svg'
  },
  muller: {
    buildType: 'MULLER',
    style: 'muller',
    logo: '../assets/img/logo_muller.svg'
  },
  elo: {
    buildType: 'ELO',
    style: 'elo',
    logo: '../assets/img/logo_elo.svg'
  },
  mrowka: {
    buildType: 'MROWKA',
    style: 'mrowka',
    logo: '../assets/img/logo_mrowka.svg'
  },
  bruendl: {
    buildType: 'BRUENDL',
    style: 'bruendl',
    logo: '../assets/img/logo_bruendl.svg'
  },
  'automotive-parts': {
    buildType: 'AUTOMOTIVE_PARTS',
    style: 'automotive-parts',
    logo: '../assets/img/logo_automotive_parts.svg'
  },
  harley: {
    buildType: 'HARLEY',
    style: 'harley',
    logo: '../assets/img/logo_harley.svg'
  },
  toolstation: {
    buildType: 'TOOLSTATION',
    style: 'toolstation',
    logo: '../assets/img/logo_toolstation.svg'
  },
  bestway: {
    buildType: 'BESTWAY',
    style: 'bestway',
    logo: '../assets/img/logo_bestway.png'
  }
}

export const getClientType = () => {
  // Check URL params first (for initial load)
  const urlParams = new URLSearchParams(window.location.search)
  const typeParam = urlParams.get('type')?.toLowerCase()

  if (typeParam && clientConfigs[typeParam]) {
    // Store in localStorage for persistence
    localStorage.setItem('clientType', typeParam)
    return typeParam
  }

  // Check localStorage for previously set type
  const storedType = localStorage.getItem('clientType')
  if (storedType && clientConfigs[storedType]) {
    return storedType
  }

  // Fall back to environment variable
  const envType = process.env.REACT_APP_BUILD_TYPE?.toLowerCase()
  if (envType && clientConfigs[envType]) {
    localStorage.setItem('clientType', envType)
    return envType
  }

  // Default to 'action'
  localStorage.setItem('clientType', 'action')
  return 'action'
}

export const getLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const langParam = urlParams.get('language')?.toLowerCase()

  if (langParam === 'pl' || langParam === 'en') {
    localStorage.setItem('clientLanguage', langParam)
    return langParam
  }

  const storedLang = localStorage.getItem('clientLanguage')
  if (storedLang === 'pl' || storedLang === 'en') {
    return storedLang
  }

  return null
}

export const getClientConfig = () => {
  const clientType = getClientType()
  return clientConfigs[clientType] || clientConfigs.action
}
